import { createTheme } from "@mui/material/styles";

const fontFamily = '"Plus Jakarta Sans", sans-serif';

const baseTheme = createTheme({
  typography: {
    fontFamily,
    fontSize: 14,
    h1: { fontFamily },
    h2: { fontFamily },
    h3: { fontFamily },
    h4: { fontFamily },
    h5: { fontFamily },
    h6: { fontFamily },
    button: { fontFamily },
  },
});

export const FALLBACK_PRIMARY = "#0D109F";
export const FALLBACK_SECONDARY = "#f50057";
export const FALLBACK_TERTIARY = "#0D109F";

export const createTenantMuiTheme = (
  primary?: string,
  secondary?: string
) => {
  return createTheme({
    ...baseTheme,
    palette: {
      primary: {
        main: primary || FALLBACK_PRIMARY,
      },
      secondary: {
        main: secondary || FALLBACK_SECONDARY,
      },
    },
  });
};

const theme = createTenantMuiTheme();

export default theme;

